export const guides = [
  {
    id: "62da1439-2f17-42e1-ab1d-d555e4106ade",
    title: "Dừng xe nhường đường cho người đi bộ",
    videoId: "7541040435288902919",
  },
  {
    id: "b2008d4c-2f27-4151-bb32-47cd1da07b69",
    title: "Ghép xe dọc vào nơi đỗ",
    videoId: "7540302780418755847",
  },
  {
    id: "907a3051-a65f-48e4-ac5f-7efe6c98af96",
    title: "Ghép ngang nào :)",
    videoId: "7539927359017749768",
  },
];